import gql from "graphql-tag";

export default gql`
  mutation ChangeCountry($country: String!) {
    changeCountry(country: $country) {
      _id
      country
    }
  }
`;
